// CountryStatusSwitcher — cage-bend #2 for ebolamap.
// Renders a floating panel (top-right of the map) that lets users pick
// which country-status dimension the choropleth layer visualises.
// The four dimensions map directly to the fields in data/country-status/*.json.

export type StatusDimension = 'burden' | 'recency' | 'vaccine_readiness' | 'preparedness';

const DIMENSIONS: { id: StatusDimension; label: string }[] = [
  { id: 'burden',            label: 'Outbreak burden' },
  { id: 'recency',           label: 'Time since last' },
  { id: 'vaccine_readiness', label: 'Vaccine readiness' },
  { id: 'preparedness',      label: 'Preparedness' },
];

export function CountryStatusSwitcher({
  value,
  onChange,
}: {
  value: StatusDimension;
  onChange: (d: StatusDimension) => void;
}) {
  return (
    <div className="bg-white/90 dark:bg-slate-900/90 rounded-lg shadow p-2 flex flex-col gap-1 text-sm pointer-events-auto">
      <div className="font-semibold text-xs uppercase tracking-wide px-1 text-slate-500">Country layer</div>
      {DIMENSIONS.map((d) => (
        <button
          key={d.id}
          type="button"
          onClick={() => onChange(d.id)}
          className={`text-left px-2 py-1 rounded transition-colors ${
            value === d.id
              ? 'bg-red-700 text-white'
              : 'text-[var(--color-text-2)] hover:bg-slate-100 dark:hover:bg-slate-800'
          }`}
        >
          {d.label}
        </button>
      ))}
    </div>
  );
}
